const BaseComponent = require('base/base-component');

class mapNav extends BaseComponent {
  init() {
    const that = this;
    // 柳州 geoJson 数据太大 单个使用 影响打包体积
    $.get('https://sitecdn.zcycdn.com/f2e-assets/3481a9e0-4669-4488-aaad-2d9af4d9b293.json', function (liuZhouGeoJson) {
      console.log('LiuZhouGeoJson', liuZhouGeoJson);
      const myChart = echarts.init(that.$el.find('.map-container')[0]);
      echarts.registerMap('LiuZhou', liuZhouGeoJson);
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: (params) => `${params.name}<br/>${params.data && params.data.value ? params.data.value : ''}`
        },
        series: [
          {
            name: '导航地图',
            type: 'map',
            zoom: 1.2,
            label: {
              show: true,
              color: '#333',
              fontSize: 8
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                color: '#333'
              }
            },
            mapType: 'LiuZhou', // 自定义扩展图表类型
            data: [
              {
                name: '三江侗族自治县',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#FCD68D'
                  }
                }
              },
              {
                name: '融水苗族自治县',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#C5E0F5'
                  }
                }
              },
              {
                name: '融安县',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#D7E8BB'
                  }
                }
              },
              {
                name: '鹿寨县',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#FDE5E5'
                  }
                }
              },
              {
                name: '柳城县',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#FFF2AF'
                  }
                }
              },
              {
                name: '柳江区',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#DDF2AF'
                  }
                }
              },
              {
                name: '柳北区',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#02C58A'
                  }
                }
              },
              {
                name: '柳南区',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#02C58A'
                  }
                }
              },
              {
                name: '鱼峰区',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#02C58A'
                  }
                }
              },
              {
                name: '城中区',
                value: '',
                itemStyle: {
                  normal: {
                    areaColor: '#02C58A'
                  }
                }
              }
            ]
          }
        ]
      });
    });
    // myChart.on('click', (params) => {
    //   let city = params.name
    //   console.log(params)
    //   params.data && params.data.value && console.log(params.data.value)
    // })
  }
}
module.exports = mapNav;
